import axios from "axios";

export function getAssignedCompanies() {
  return axios.get("/partner/api/v1/companies");
}

export function getCompanyUsers(companyUuid) {
  return axios.get(`/partner/api/v1/companies/${companyUuid}/users`);
}

export function getUserCredit(userSub) {
  return axios.get(`/partner/api/v1/credit-transfer/user-credit/${userSub}`);
}

export function submitCreditTransfer(data) {
  return axios.post("/partner/api/v1/credit-transfer", data);
}

